export const wpSetting = ({ setting, defaultValue, getter, setter, ...rest }) => {
	const key = `wp.post_meta._omapi_${setting}`;
	function get() {
		const value = this.$get(`campaign.${key}`, defaultValue);
		return getter ? getter.call(this, value, key) : value;
	}
	return {
		get,
		set(value) {
			value = setter ? setter.call(this, value, key, get.bind(this)) : value;
			this.updateCampaignValue({
				campaignId: this.id,
				key,
				value,
				...rest,
			});
		},
	};
};
